const AuthReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN_START":
      return {
        user: null,
        isFetching: true,
        error: false,
        errorMessage: "",
        shop: null
      };
    case "LOGIN_SUCCESS":
      let shop = null
      if(action.payload.allowedShops && action.payload.allowedShops.length === 1) shop = action.payload.allowedShops[0]
      return {
        user: action.payload,
        isFetching: false,
        error: false,
        errorMessage: "",
        shop
      };
    case "LOGIN_FAILURE":
      return {
        user: null,
        isFetching: false,
        error: true,
        errorMessage: action.payload,
        shop: null
      };
    case "LOGOUT":
      localStorage.removeItem("user")
      localStorage.removeItem("shop")
      return {
        user: null,
        isFetching: false,
        error: false,
        errorMessage: "",
        shop: null
      };
    case "SET_SHOP":
      return {
        user: action.payload.user,
        isFetching: false,
        error: false,
        errorMessage: "",
        shop: action.payload.shop
      };
    default:
      return { ...state };
  }
};

export default AuthReducer;
